const bugsnagMock = {
  notify: () => {
    // console.info('Bugsnag mock: error reported')
  },
}

export default {
  install(app) {
    app.config.globalProperties.$bugsnag = bugsnagMock
  },
}
